// TODO: Coralogix cleanup - This entire file can be removed once migration to BetterStack is complete
import WinstonTransport from 'winston-transport';
import { CoralogixLogger, Severity, type CoralogixLog } from './coralogix-logger';
import type { LogEntry } from 'winston';

export interface CoralogixTransportOptions extends WinstonTransport.TransportStreamOptions {
    category: string;
}

const severityMap = {
    debug: Severity.debug,
    silly: Severity.verbose,
    verbose: Severity.verbose,
    silent: Severity.verbose,
    info: Severity.info,
    http: Severity.info,
    warn: Severity.warning,
    warning: Severity.warning,
    error: Severity.error,
    critical: Severity.critical,
    crit: Severity.critical,
} as const;

const errorProps = ['err', 'error', 'reason', 'e'];

export class CoralogixTransport extends WinstonTransport {
    name: string;
    private category: string;
    private logger: CoralogixLogger;

    constructor(options: CoralogixTransportOptions) {
        super(options);
        this.name = 'Coralogix Transport';
        this.category = options.category;

        this.logger = new CoralogixLogger({
            applicationName: 'testim',
            subsystemName: 'runner',
        });
    }

    log(info: LogEntry, callback: (...args: unknown[]) => void): void {
        const { category, level, message: msg, meta: infoMeta = {}, ...restMeta } = info;
        const meta = { ...infoMeta, ...restMeta };

        const log: CoralogixLog = {
            severity: severityMap[level as keyof typeof severityMap],
            text: msg,
            category: category || this.category,
        };

        if (meta.className) log.className = meta.className;
        if (meta.methodName) log.methodName = meta.methodName;
        if (meta.threadId) log.threadId = meta.threadId;

        delete meta.className;
        delete meta.methodName;
        delete meta.threadId;
        delete meta.category;
        delete meta.level;
        delete meta.message;

        let errorOverride = false;
        if (infoMeta instanceof Error) {
            errorOverride = true;
            meta.msg = infoMeta.message + infoMeta.stack;
            if (msg) meta.msg = `${msg}\n${meta.msg}`;
        }

        for (const prop of errorProps) {
            if (infoMeta[prop] instanceof Error) {
                meta[prop] = {
                    message: infoMeta[prop].message,
                    stack: infoMeta[prop].stack,
                    name: infoMeta[prop].name,
                    type: (infoMeta[prop] as any).type,
                    cause: infoMeta[prop].cause,
                    ...(infoMeta[prop] as any),
                };
            }
        }

        if (Object.keys(meta).length > 0) {
            if (msg && !errorOverride) meta.msg = msg;
            log.text = JSON.stringify(meta);
        }

        this.logger.addLog(log);
        callback(null, true);
    }

    setProxy(proxy: string): void {
        this.logger.setProxy(proxy);
    }

    async waitForFlush(): Promise<void> {
        return await this.logger.waitForFlush();
    }
}
